<template>
  <FileSelectWrapper
    :validFormats="$constants.fileAttachments.acceptedFormats"
    @selected="$emit('filesSelected', $event)"
  >
    <template slot-scope="{ selectFile, isDraggingFile }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <Button
            v-on="on"
            class="flex-column uploader-container blue-grey lighten-3"
            icon="mdi-file-plus"
            outlined
            :class="{
              'uploader-container--dragging': isDraggingFile,
              'uploader-container--small': small,
            }"
            :color="isDraggingFile ? 'primary' : 'blueGrey'"
            :loading="isUploading"
            @click="selectFile"
          />
        </template>

        {{ $t('attachments.attach_a_file') }}
      </v-tooltip>
    </template>
  </FileSelectWrapper>
</template>

<script>
import FileSelectWrapper from '@/components/utils/FileSelectWrapper/FileSelectWrapper.vue'
import Button from '@/components/UI/Button'

export default {
  name: 'AttachmentUploader',

  components: {
    Button,
    FileSelectWrapper,
  },

  props: {
    isUploading: Boolean,
    isDraggingFile: Boolean,
    small: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.uploader-container {
  width: 80px !important;
  height: 80px !important;
  min-width: 80px !important;
  max-width: 80px !important;
  border-radius: 12px;

  &--small {
    width: 60px !important;
    height: 60px !important;
    min-width: 60px !important;
    max-width: 60px !important;
    border-radius: 8px;
  }

  &--dragging {
    background-color: var(--v-blue-lighten5);
    border-color: var(--v-primary-base);
  }
}
</style>
